export type MpUserSelfWecomPushMsgtype = 'text' | 'markdown';

export function mpUserWecomDefaultReviewTemplate(msgtype: MpUserSelfWecomPushMsgtype = 'text'): string {
  if (msgtype === 'markdown') {
    return `【贴图虾】**用户发布待审核**
> 小程序：**{minipro_name}**
> 站点：**{site_name}**
> 标题：{title}
> 发布者：{publisher_nickname}
> 类型：{action_label}
> 条目ID：\`{entry_id}\`
> 时间：{time}
> [站长审核]({review_url})`;
  }
  return `【贴图虾】用户发布待审核
小程序：{minipro_name}
站点：{site_name}
标题：{title}
发布者：{publisher_nickname}
类型：{action_label}
条目ID：{entry_id}
时间：{time}
请用手机打开链接审核：
{review_url}`;
}

export function mpUserWecomDefaultPublishedTemplate(msgtype: MpUserSelfWecomPushMsgtype = 'text'): string {
  if (msgtype === 'markdown') {
    return `【贴图虾】**用户发布已上线**
> 小程序：**{minipro_name}**
> 站点：**{site_name}**
> 标题：{title}
> 发布者：{publisher_nickname}
> 类型：{action_label}
> 条目ID：\`{entry_id}\`
> 时间：{time}
> 摘要：{body_excerpt}
> [查看信息]({entry_url})`;
  }
  return `【贴图虾】用户发布已上线
小程序：{minipro_name}
站点：{site_name}
标题：{title}
发布者：{publisher_nickname}
类型：{action_label}
条目ID：{entry_id}
时间：{time}
摘要：{body_excerpt}
查看信息：
{entry_url}`;
}

export function mpUserWecomDefaultProfileTemplate(msgtype: MpUserSelfWecomPushMsgtype = 'text'): string {
  if (msgtype === 'markdown') {
    return `【贴图虾】**用户资料待审核**
> 小程序：**{minipro_name}**
> 用户：{publisher_nickname}
> 待审昵称：{pending_nickname}
> 时间：{time}
> [打开用户管理]({users_url})`;
  }
  return `【贴图虾】用户资料待审核
小程序：{minipro_name}
用户：{publisher_nickname}
待审昵称：{pending_nickname}
时间：{time}
请打开用户管理：
{users_url}`;
}

export type MpUserSelfWecomPush = {
  enabled: boolean;
  webhook_url: string;
  msgtype: MpUserSelfWecomPushMsgtype;
  on_entry_review: boolean;
  on_entry_published: boolean;
  on_profile_review: boolean;
  body_template: string;
  published_body_template: string;
  profile_body_template: string;
};

export function defaultMpUserSelfWecomPush(): MpUserSelfWecomPush {
  return {
    enabled: false,
    webhook_url: '',
    msgtype: 'text',
    on_entry_review: true,
    on_entry_published: true,
    on_profile_review: false,
    body_template: mpUserWecomDefaultReviewTemplate('text'),
    published_body_template: mpUserWecomDefaultPublishedTemplate('text'),
    profile_body_template: mpUserWecomDefaultProfileTemplate('text'),
  };
}

export function normalizeMpUserSelfWecomPush(raw: unknown): MpUserSelfWecomPush {
  const d = defaultMpUserSelfWecomPush();
  if (!raw || typeof raw !== 'object') return d;
  const o = raw as Record<string, unknown>;
  const msgtype = String(o.msgtype || d.msgtype).trim() === 'markdown' ? 'markdown' : 'text';
  const bodyRaw = String(o.body_template ?? '').trim();
  const publishedRaw = String(o.published_body_template ?? '').trim();
  const profileRaw = String(o.profile_body_template ?? '').trim();
  return {
    enabled: o.enabled !== undefined ? !!o.enabled : d.enabled,
    webhook_url: String(o.webhook_url || d.webhook_url).trim(),
    msgtype,
    on_entry_review: o.on_entry_review !== undefined ? !!o.on_entry_review : d.on_entry_review,
    on_entry_published: o.on_entry_published !== undefined ? !!o.on_entry_published : d.on_entry_published,
    on_profile_review: o.on_profile_review !== undefined ? !!o.on_profile_review : d.on_profile_review,
    body_template: bodyRaw || mpUserWecomDefaultReviewTemplate(msgtype),
    published_body_template: publishedRaw || mpUserWecomDefaultPublishedTemplate(msgtype),
    profile_body_template: profileRaw || mpUserWecomDefaultProfileTemplate(msgtype),
  };
}
